"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByFavoriteId = exports.sortBySportId = exports.sortById = exports.sortByScheduledTime = exports.sortByCasinoTagsOrder = exports.sortByNumberAfterLastSpace = exports.sortByNumberBetweenBrackets = exports.sortSetWinnerMarkets = exports.sortAlphabeticallyByProp = exports.sortLiveTopLeagues = exports.sortSports = exports.CASINO_TAGS_ORDER_COMPACT = exports.CASINO_TAGS_ORDER = void 0;
const enums_1 = require("@finbackoffice/enums");
const constants_1 = require("../constants");
exports.CASINO_TAGS_ORDER = [enums_1.CasinoGameTag.New, enums_1.CasinoGameTag.Popular];
exports.CASINO_TAGS_ORDER_COMPACT = [
    enums_1.CasinoGameTag.Popular,
    enums_1.CasinoGameTag.Hot,
    enums_1.CasinoGameTag.Top,
    enums_1.CasinoGameTag.New,
    enums_1.CasinoGameTag.CrashGame,
    enums_1.CasinoGameTag.Football,
];
const SPORTS_ORDER = [
    constants_1.SportTypes.SOCCER,
    constants_1.SportTypes.BASKETBALL,
    constants_1.SportTypes.BASEBALL,
    constants_1.SportTypes.VOLLEYBALL,
    constants_1.SportTypes.ICE_HOCKEY,
    constants_1.SportTypes.TENNIS,
];
const sortSports = (a, b) => {
    if (!SPORTS_ORDER.includes(a.id)) {
        return 1;
    }
    if (!SPORTS_ORDER.includes(b.id)) {
        return -1;
    }
    return SPORTS_ORDER.indexOf(a.id) - SPORTS_ORDER.indexOf(b.id);
};
exports.sortSports = sortSports;
const sortLiveTopLeagues = (a, b) => {
    if (!SPORTS_ORDER.includes(a.sport_id)) {
        return 1;
    }
    if (!SPORTS_ORDER.includes(b.sport_id)) {
        return -1;
    }
    return SPORTS_ORDER.indexOf(a.sport_id) - SPORTS_ORDER.indexOf(b.sport_id);
};
exports.sortLiveTopLeagues = sortLiveTopLeagues;
const sortAlphabeticallyByProp = (prop) => (item1, item2) => {
    if (item1[prop] > item2[prop]) {
        return 1;
    }
    if (item1[prop] < item2[prop]) {
        return -1;
    }
    return 0;
};
exports.sortAlphabeticallyByProp = sortAlphabeticallyByProp;
const sortSetWinnerMarkets = (a, b) => {
    if (a.template_id === constants_1.TemplateIdsMap.SETNUMBER_SET_WINNER &&
        b.template_id === constants_1.TemplateIdsMap.SETNUMBER_SET_WINNER) {
        const aName = a.name || "";
        const bName = b.name || "";
        const rgx = /[0-9]+/;
        const extractANumber = rgx.exec(aName)?.[0];
        const extractBNumber = rgx.exec(bName)?.[0];
        if (extractANumber && extractBNumber) {
            return parseFloat(extractANumber) - parseFloat(extractBNumber);
        }
    }
    return 0;
};
exports.sortSetWinnerMarkets = sortSetWinnerMarkets;
const sortByNumberBetweenBrackets = (a, b) => {
    const aName = a.outcomes[0].name ?? "";
    const bName = b.outcomes[0].name ?? "";
    const rgx = /\((.+?)\)/;
    const extractANumber = rgx.exec(aName)?.[1];
    const extractBNumber = rgx.exec(bName)?.[1];
    if (extractANumber && extractBNumber) {
        return parseFloat(extractANumber) - parseFloat(extractBNumber);
    }
    return 0;
};
exports.sortByNumberBetweenBrackets = sortByNumberBetweenBrackets;
const sortByNumberAfterLastSpace = (a, b) => {
    const aName = a.outcomes[0].name ?? "";
    const bName = b.outcomes[0].name ?? "";
    const rgx = /[\S]+$/;
    const extractANumber = rgx.exec(aName)?.[0];
    const extractBNumber = rgx.exec(bName)?.[0];
    if (extractANumber && extractBNumber) {
        return parseFloat(extractANumber) - parseFloat(extractBNumber);
    }
    return 0;
};
exports.sortByNumberAfterLastSpace = sortByNumberAfterLastSpace;
const sortByCasinoTagsOrder = (a, b) => exports.CASINO_TAGS_ORDER.indexOf(a) - exports.CASINO_TAGS_ORDER.indexOf(b);
exports.sortByCasinoTagsOrder = sortByCasinoTagsOrder;
const sortByScheduledTime = (a, b) => {
    if (a.scheduled_at && b.scheduled_at) {
        return (new Date(a.scheduled_at).getTime() - new Date(b.scheduled_at).getTime());
    }
    return 0;
};
exports.sortByScheduledTime = sortByScheduledTime;
const sortById = (a, b) => a.id - b.id;
exports.sortById = sortById;
const sortBySportId = (a, b) => a.sport_id - b.sport_id;
exports.sortBySportId = sortBySportId;
const sortByFavoriteId = (favoriteMarketsIds) => (m1, m2) => {
    const indexofM1 = favoriteMarketsIds.indexOf(m1.favId);
    const indexofM2 = favoriteMarketsIds.indexOf(m2.favId);
    if (indexofM1 !== -1 && indexofM2 === -1) {
        return -1;
    }
    if (indexofM1 === -1 && indexofM2 !== -1) {
        return 1;
    }
    if (indexofM1 !== -1 && indexofM2 !== -1) {
        return indexofM1 - indexofM2;
    }
    return m1.rank - m2.rank;
};
exports.sortByFavoriteId = sortByFavoriteId;
//# sourceMappingURL=sorting.js.map